module.exports = __webpack_public_path__ + "static/media/6.495ff1ec.JPG";